import { CLI_DEFAULT_ROLE, CLI_ROLE_RANK } from 'constants/cliRoles';
import { CliCommandSpec } from 'types/cli';

export const cliRoleRank = (role: string | null | undefined) =>
  CLI_ROLE_RANK[role || CLI_DEFAULT_ROLE] ?? 0;

const TOP_RANK = Math.max(...Object.values(CLI_ROLE_RANK));

export const cliRoleLabel = (role: string) => {
  const name = role.charAt(0).toUpperCase() + role.slice(1);
  return cliRoleRank(role) === TOP_RANK ? `${name} only` : `${name} and above`;
};

export interface CliRoleGroup {
  role: string;
  label: string;
  commands: CliCommandSpec[];
}

export function groupByLeastRole(commands: CliCommandSpec[]): CliRoleGroup[] {
  const byRole = new Map<string, CliCommandSpec[]>();
  commands.forEach(command => {
    const role = command.permission || CLI_DEFAULT_ROLE;
    byRole.set(role, [...(byRole.get(role) ?? []), command]);
  });
  return [...byRole.entries()]
    .sort(([a], [b]) => cliRoleRank(a) - cliRoleRank(b) || a.localeCompare(b))
    .map(([role, list]) => ({
      role,
      label: cliRoleLabel(role),
      commands: list,
    }));
}

const READY_TO_RUN: Record<string, string> = { 'exec:upload': 'upload .' };
const USAGE_ALTERNATIVES = '  |  ';

// `history [-n LINES]` already names its group, and `cp -i  |  cp SRC DEST` offers two forms.
export function commandLine({ category, command, usage }: CliCommandSpec) {
  const ready = READY_TO_RUN[`${category}:${command}`];
  if (ready) return `${category} ${ready}`;
  const first = usage.split(USAGE_ALTERNATIVES)[0];
  return first === category || first.startsWith(`${category} `)
    ? first
    : `${category} ${first}`;
}

export const commandKey = ({ category, command }: CliCommandSpec) =>
  `${category}:${command}`;
